import React from "react";

/**
 * CineIcon — wraps a flat (lucide) icon in a dimensional, gold-aware tile.
 * Turns thin line icons into tactile "badges": gradient fill, inner highlight,
 * soft shadow, and a gold glow + drop-shadow when active. Reusable anywhere a
 * flat icon currently sits.
 *
 * Props: icon (lucide component), active, size (tile px), iconSize, className
 */
export default function CineIcon({ icon: Icon, active = false, size = 36, iconSize, className = "" }) {
  const isz = iconSize || Math.round(size * 0.5);
  return (
    <span
      className={`relative grid place-items-center rounded-xl flex-shrink-0 overflow-hidden ${className}`}
      style={{
        width: size,
        height: size,
        background: active
          ? "linear-gradient(150deg, rgba(245,200,66,0.22), rgba(184,146,58,0.08))"
          : "linear-gradient(150deg, var(--bg-elevated), var(--bg-overlay))",
        border: active ? "1px solid rgba(212,168,83,0.5)" : "1px solid var(--border-default)",
        boxShadow: active
          ? "var(--glow-gold), inset 0 1px 0 rgba(255,255,255,0.12)"
          : "var(--shadow-sm), inset 0 1px 0 rgba(255,255,255,0.05)",
      }}
    >
      {/* top sheen for a dimensional, lit-from-above feel */}
      <span
        className="pointer-events-none absolute inset-x-0 top-0 h-1/2"
        style={{ background: "linear-gradient(180deg, rgba(255,255,255,0.08), transparent)" }}
      />
      {Icon && (
        <Icon
          size={isz}
          strokeWidth={1.75}
          className={active ? "text-[var(--color-gold-300)]" : "text-[var(--text-secondary)]"}
          style={active ? { filter: "drop-shadow(0 1px 4px rgba(212,168,83,0.45))" } : undefined}
        />
      )}
    </span>
  );
}
